import { render, staticRenderFns } from "./p12.vue?vue&type=template&id=fffc825a&scoped=true&"
import script from "./p12.vue?vue&type=script&lang=js&"
export * from "./p12.vue?vue&type=script&lang=js&"
import style0 from "./p12.vue?vue&type=style&index=0&id=fffc825a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffc825a",
  null
  
)

export default component.exports